import {React, useState} from "react";
import Header from "../components/Header";
import { HiSearch } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import AdminSideBar from "../components/AdminSideBar";
import Footer from "../components/Footer";

const editicon = "/editicon.png";
const view = "/View.png";
const trash = "/Trash.png";
const importing = "/importicon.png";

const stopplayicon = "/stopplayicon.png";
const addicon = "/addicon.png";
const levels = ["Level 5", "Level 4", "Level 3", "Level 2", "Level 1"];

const rows = [
  {
    name: "Juma Jembe",
    email: "juma.jembe@farmnet.africa",
    password: "AlphaNumeric9?!",
  },
  {
    name: "Juma Jembe",
    email: "juma.jembe@farmnet.africa",
    password: "AlphaNumeric9?!",
  },
  {
    name: "Juma Jembe",
    email: "juma.jembe@farmnet.africa",
    password: "AlphaNumeric9?!",
  },
  {
    name: "Juma Jembe",
    email: "juma.jembe@farmnet.africa",
    password: "AlphaNumeric9?!",
  },
  {
    name: "Juma Jembe",
    email: "juma.jembe@farmnet.africa",
    password: "AlphaNumeric9?!",
  },
  {
    name: "Juma Jembe",
    email: "juma.jembe@farmnet.africa",
    password: "AlphaNumeric9?!",
  },
  {
    name: "Juma Jembe",
    email: "juma.jembe@farmnet.africa",
    password: "AlphaNumeric9?!",
  },
];

const UserAccount = () => {
  const [selectedLevel, setSelectedLevel] = useState("Level 5");
  const [tableData, setTableData] = useState(rows);
  const [isViewMode, setIsViewMode] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isSuspended, setIsSuspended] = useState(false);
  const [headerInputs, setHeaderInputs] = useState({
    name: "Juma Jembe",
    email: "juma.jembe@farmnet.africa",
    password: "AlphaNumeric9?!"
  });

  const handleView = () => {
    setIsViewMode(!isViewMode);
  };

  const handleEdit = () => {
    setIsEditing(!isEditing);
  };

  const handleAdd = () => {
    const newRow = {
      name: "New User",
      email: "new@farmnet.africa",
      password: "NewPassword123",
    };
    setTableData([...tableData, newRow]);
  };

  const handleSuspend = () => {
    setIsSuspended(!isSuspended);
  };

  const handleDelete = () => {
    if (tableData.length > 0) {
      const newData = tableData.slice(0, -1);
      setTableData(newData);
    }
  };

  const handleUpdateRow = (index, field, value) => {
    const newData = [...tableData];
    newData[index] = { ...newData[index], [field]: value };
    setTableData(newData);
  };

  const handleHeaderChange = (field, value) => {
    setHeaderInputs({
      ...headerInputs,
      [field]: value
    });
  };

  return (
    <div className="bg-[#FAFBFB]">
      <Header/>
      <div className="flex flex-col min-h-screen ">
        <div className="flex flex-grow">
          <div className="hidden md:block">
            <AdminSideBar />
          </div>
          <div className="flex-grow p-2 md:p-4 md:px-6 flex flex-col w-full">
            <div className="flex flex-col lg:flex-row lg:justify-between items-center gap-4">
              <h1 className="font-bold text-[20px] md:text-[24px]">USER ACCESS RIGHTS</h1>

              <div className="relative w-full lg:w-auto">
                <input
                  type="text"
                  placeholder="Search"
                  className="md:w-[600px] w-full h-[45px] md:h-[57px] text-[#919291] text-[14px] md:text-[15px] font-medium p-3 pr-10 border-[3px] border-[#D9D9D9] rounded-md focus:outline-none focus:ring-2 focus:ring-green-600"
                />
                <HiSearch
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-black"
                  size={20}
                />
              </div>
            </div>

            {/* Sub Nav */}
            <div className="flex flex-wrap gap-2 py-4 w-full">
              {levels.map((level) => (
                <div
                  key={level}
                  className={`text-[13px] md:text-[15px] font-medium h-[60px] md:h-[80px] rounded-md p-2 md:p-4 flex-grow cursor-pointer transition-all duration-300 ${
                    selectedLevel === level 
                      ? 'bg-[#152C24] text-white' 
                      : 'bg-[#EDF0EF] hover:bg-[#152C24] hover:text-white'
                  }`}
                  onClick={() => setSelectedLevel(level)}
                >
                  <span className="block text-[16px] md:text-[20px] font-bold">{level}</span>
                  <span className="block text-[14px] md:text-[16px] font-normal">Access Rights</span>
                </div>
              ))}
            </div>

            {/* User Access Rights Section */}
            <div className="flex flex-col md:flex-row justify-between items-center mt-1 mb-2 gap-2">
              <h1 className="text-[14px] md:text-[16px] font-bold">User Access rights</h1>
              <div 
                className="flex items-center gap-2 cursor-pointer"
                onClick={handleAdd}
              >
                <span className="text-[14px] md:text-[16px] font-medium text-[#919291]">Add user</span>
                <img src={addicon} alt="Add Icon" className="w-4 h-4 md:w-5 md:h-5" />
              </div>
            </div>

            {/* User Information & Dynamic Rows */}
            <div className="flex flex-col md:flex-row gap-4 w-full">
              <div className="w-full md:w-[25%]">
                <h1 className="text-[13px] md:text-[15px] font-medium bg-[#EDF0EF] w-full h-[55px] md:h-[65px] rounded-md p-2">
                  <span className="block text-[16px] md:text-[20px] font-extrabold">{selectedLevel}</span>
                  <span className="block text-[14px] md:text-[16px] font-medium">Access Rights</span>
                </h1>
                <div className="bg-[#FFF9F0] h-auto flex flex-col p-3 md:p-4 gap-4 md:gap-11">
                  <div className="flex items-center gap-2 cursor-pointer" onClick={handleView}>
                    <img src={view} alt="View" className="w-[18px] h-[18px] md:w-[20px] md:h-[20px]" />
                    <h1 className="text-[15px] md:text-[20px] font-bold">View</h1>
                  </div>
                  <div className="flex items-center gap-2 cursor-pointer" onClick={handleEdit}>
                    <img src={editicon} alt="Edit" className="w-[18px] h-[18px] md:w-[20px] md:h-[20px]" />
                    <h1 className="text-[15px] md:text-[20px] font-bold">Edit</h1>
                  </div>
                  <div className="flex items-center gap-2 cursor-pointer" onClick={handleAdd}>
                    <img src={addicon} alt="Add" className="w-[18px] h-[18px] md:w-[20px] md:h-[20px]" />
                    <h1 className="text-[15px] md:text-[20px] font-bold">Add</h1>
                  </div>
             
                  <div className="flex items-center gap-2 cursor-pointer" onClick={handleDelete}>
                    <img src={trash} alt="Delete" className="w-[18px] h-[18px] md:w-[20px] md:h-[20px]" />
                    <h1 className="text-[15px] md:text-[20px] font-bold">Save</h1>
                  </div>
                  <div className="flex items-center gap-2 cursor-pointer" onClick={handleSuspend}>
                    <img src={stopplayicon} alt="Suspend" className="w-[18px] h-[18px] md:w-[20px] md:h-[20px]" />
                    <h1 className="text-[15px] md:text-[20px] font-bold">Suspend</h1>
                  </div>
                  <div className="flex items-center gap-2 cursor-pointer" onClick={handleDelete}>
                    <img src={importing} alt="Delete" className="w-[18px] h-[18px] md:w-[20px] md:h-[20px]" />
                    <h1 className="text-[15px] md:text-[20px] font-bold">Download</h1>
                  </div>
                  <div className="flex items-center gap-2 cursor-pointer" onClick={handleDelete}>
                    <img src={trash} alt="Delete" className="w-[18px] h-[18px] md:w-[20px] md:h-[20px]" />
                    <h1 className="text-[15px] md:text-[20px] font-bold">Delete</h1>
                  </div>
                </div>
              </div>

              <div className="w-full">
                {/* Headers as inputs with original text */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                  <div className="text-[13px] md:text-[15px] font-medium bg-[#FAFBFB] border border-[#919291] w-full h-[60px] md:h-[75px] rounded-md ">
                    <span className="block text-[14px] md:text-[16px] font-bold ml-2">Name</span>
                    <input
                      type="text"
                      value={headerInputs.name}
                      onChange={(e) => handleHeaderChange('name', e.target.value)}
                      className="block text-[14px] md:text-[16px] font-normal border-none bg-transparent w-full outline-none"
                    />
                  </div>

                  <div className="text-[13px] md:text-[15px] font-medium bg-[#FAFBFB] border border-[#919291] w-full h-[60px] md:h-[75px] rounded-md">
                    <span className="block text-[14px] md:text-[16px] font-bold ml-2">Email</span>
                    <input
                      type="text"
                      value={headerInputs.email}
                      onChange={(e) => handleHeaderChange('email', e.target.value)}
                      className="block text-[14px] md:text-[16px] font-normal border-none bg-transparent w-full outline-none"
                    />
                  </div>

                  <div className="text-[13px] md:text-[15px] font-medium bg-[#FAFBFB] border border-[#919291] w-full h-[60px] md:h-[75px] rounded-md ">
                    <span className="block text-[14px] md:text-[16px] font-bold ml-2"  >Password</span>
                    <input
                      type="text"
                      value={headerInputs.password}
                      onChange={(e) => handleHeaderChange('password', e.target.value)}
                      className="block text-[14px] md:text-[16px] font-normal border-none bg-transparent w-full outline-none"
                    />
                  </div>
                </div>

                {/* Dynamic Rows */}
                <div className="mt-4 space-y-2">
                  {tableData.map((row, index) => (
                    <div 
                      key={index}
                      className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1 ${
                        isSuspended ? 'opacity-50' : ''
                      }`}
                    >
                      {isEditing ? (
                        <>
                          <input
                            type="text"
                            value={row.name}
                            onChange={(e) => handleUpdateRow(index, 'name', e.target.value)}
                            className="text-[14px] md:text-[16px] font-normal bg-white border border-gray-300 w-full h-[45px] md:h-[60px] rounded-md p-2"
                          />
                          <input
                            type="email"
                            value={row.email}
                            onChange={(e) => handleUpdateRow(index, 'email', e.target.value)}
                            className="text-[14px] md:text-[16px] font-normal bg-white border border-gray-300 w-full h-[45px] md:h-[60px] rounded-md p-2"
                          />
                          <input
                            type="text"
                            value={row.password}
                            onChange={(e) => handleUpdateRow(index, 'password', e.target.value)}
                            className="text-[14px] md:text-[16px] font-normal bg-white border border-gray-300 w-full h-[45px] md:h-[60px] rounded-md p-2"
                          />
                        </>
                      ) : (
                        <>
                          <div className="text-[14px] md:text-[16px] font-normal bg-[#EDF0EF] w-full h-[45px] md:h-[60px]  rounded-md p-2 flex items-center">
                            {isViewMode ? row.name : '•'.repeat(row.name.length)}
                          </div>
                          <div className="text-[14px] md:text-[16px] font-normal bg-[#EDF0EF] w-full h-[45px] md:h-[60px] rounded-md p-2 flex items-center">
                            {isViewMode ? row.email : '•'.repeat(row.email.length)}
                          </div>
                          <div className="text-[14px] md:text-[16px] font-normal bg-[#EDF0EF] w-full h-[45px] md:h-[60px]  rounded-md p-2 flex items-center">
                            {isViewMode ? row.password : '•'.repeat(row.password.length)}
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end md:p-4 p-2">
        <button className="md:w-[270px] md:h-[50px] rounded-[5px] text-white font-bold text-[20px] bg-[#152C24]">Assign User rights</button>
      </div>
        <div className="mt-auto">
          <Footer />
        </div>
      </div>
     
    </div>
  );
};

export default UserAccount;